import { Box } from '@mui/material';
import { RenderTable } from '../../../../components/ui';
import TBody from './TBody';
import THead from './THead';

interface IProps {
  moduleData: any;
  isView: boolean;
  handelDeleteRows: any;
  downTimes: any;
}

const TController = ({
  moduleData,
  isView,
  handelDeleteRows,
  downTimes,
}: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            moduleData,
            isView,
          }}
        />
        <TBody
          {...{
            moduleData,
            downTimes,
            isView,
            handelDeleteRows,
          }}
        />
      </RenderTable>
    </Box>
  );
};

export default TController;
